import { ClickAwayListener, IconButton } from '@mui/material'
import { SearchIcon } from 'assets/icons'
import { t } from 'i18next'
import SearchPopup, { SEARCH_MODE } from './popups/searchItems/SearchPopup'
import GroupcalTooltip from './tooltips/GroupcalTooltip'
import { useState } from 'react'
import { CircleIconButton } from './styled'
import { theme } from 'theme'
import i18n from 'i18n'

export interface SearchEventsPopupProps {
  mode: SEARCH_MODE
  groupId?: string
  textfieldPlaceholder?: string
  keepBorder?: boolean
}

export default function SearchPopupButton(props: SearchEventsPopupProps) {
  const [searchState, setSearchState] = useState(false)

  const showSearch = () => {
    setSearchState(true)
  }

  const hideSearch = () => {
    setSearchState(false)
  }
  return (
    <ClickAwayListener
      mouseEvent="onMouseDown"
      touchEvent="onTouchStart"
      onClickAway={hideSearch}
    >
      <div>
        <SearchPopup
          groupId={props.groupId}
          mode={props.mode}
          open={searchState}
          setOpen={setSearchState}
          textfieldPlaceholder={props.textfieldPlaceholder}
        >
          <span onClick={showSearch}>
            <GroupcalTooltip title={t('search')}>
              <CircleIconButton
                sx={{
                  width: '52px',
                  height: '52px',
                  marginLeft: 0,
                  marginRight: 0,
                  ...(props.keepBorder
                    ? {
                        border: '1px solid #e4e4e4 !important',
                        boxShadow:
                          '1px 1px 6px 0px rgba(50, 50, 71, 0.05) !important'
                      }
                    : {
                        [theme.breakpoints.down('lg')]: {
                          width: 'auto',
                          height: 'auto',
                          marginLeft: i18n.dir() === 'ltr' ? '5px' : undefined,
                          marginRight: i18n.dir() === 'rtl' ? '5px' : undefined
                        }
                      })
                }}
              >
                <SearchIcon />
              </CircleIconButton>
            </GroupcalTooltip>
          </span>
        </SearchPopup>
      </div>
    </ClickAwayListener>
  )
}
